export default __webpack_public_path__ + "static/media/option.fe300cd4.png";